import { render, staticRenderFns } from "./FoldOutCard.vue?vue&type=template&id=2fdb5a5d"
import script from "./FoldOutCard.vue?vue&type=script&lang=js"
export * from "./FoldOutCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports